import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-800 shadow rounded-lg border border-gray-200 dark:border-gray-700" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "text-lg font-medium text-gray-900 dark:text-white" }
const _hoisted_5 = { class: "ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200" }
const _hoisted_6 = { class: "px-6 pb-4 border-t border-gray-200 dark:border-gray-700" }

interface Props {
  title: string
  count: number
  isExpanded: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ExpandableSection',
  props: {
    title: {},
    count: {},
    isExpanded: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle'))),
      class: "w-full px-6 py-4 text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.title), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.count), 1)
        ]),
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass(["w-5 h-5 text-gray-500 dark:text-gray-400 transform transition-transform duration-200", { 'rotate-180': _ctx.isExpanded }]),
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 9l-7 7-7-7"
          }, null, -1)
        ]), 2))
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, _ctx.isExpanded]
    ])
  ]))
}
}

})